import debounce from 'lodash.debounce';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';
import { REDUX_FAVOURITES_RESET_FAVS_ADDED } from 'redux-state/favourites/reducer.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { UsePageFavouriteProps } from './page-favourite-properties.js';

export const FavouritesAddedHook = (): {
  displayFavAdded: boolean;
} => {
  const appDispatch = useAppDispatch();
  const { displayFavouriteIcon } = UsePageFavouriteProps();
  const favsAdded = useAppSelector((s: IRepoState) => s.FAVOURITES.favsAdded);
  const [displayFavAdded, setDisplayFavAdded] = React.useState(false);

  /**
   * When adding a reference we add a flag to say they have been updated
   * The popover listens to this flag and displays the popover
   * After 2_500ms we hide the flag so the popover disappears
   */
  const hideFavAdded = React.useRef(
    debounce(() => {
      setDisplayFavAdded(false);
      appDispatch(REDUX_FAVOURITES_RESET_FAVS_ADDED());
    }, 2500),
  );

  React.useEffect(() => {
    if (displayFavouriteIcon) {
      if (favsAdded) {
        setDisplayFavAdded(true);
        /** Hide after 2500 */
        hideFavAdded.current();
      } else {
        setDisplayFavAdded(false);
      }
    }
  }, [displayFavouriteIcon, favsAdded, appDispatch]);

  return {
    displayFavAdded,
  };
};
